module.exports = __webpack_public_path__ + "static/media/skybox_internal_view_pc.83fd104c.jpg";